import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { of, switchMap } from 'rxjs';

export const NoAuthGuard: CanActivateFn | CanActivateChildFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
{
    const router: Router = inject(Router);

    // Check the authentication status
    return inject(AuthService).check().pipe(
        switchMap((authenticated) =>
        {
            // If the user is authenticated...
            if ( authenticated )
            {
                // If the sign-in URL has leave approval params, redirect to /email with those params
                const requestedLeaveId = route.queryParams['requestedLeaveId'];
                const approveId = route.queryParams['approveId'];
                const teamLeadId = route.queryParams['teamLeadId'];
                const rejectId = route.queryParams['rejectId'];

                if (requestedLeaveId && (approveId || rejectId)) {
                    const urlTree = router.createUrlTree(['/email'], {
                        queryParams: { requestedLeaveId, approveId, teamLeadId, rejectId }
                    });
                    return of(urlTree);
                }

                return of(router.parseUrl(''));
            }

            // Allow the access
            return of(true);
        }),
    );
};
